'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// import {SlideDown} from 'react-slidedown'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _HowItWorks = require('./HowItWorks.css');

var _HowItWorks2 = _interopRequireDefault(_HowItWorks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HowItWorks = (_dec = (0, _reactCssModules2.default)(_HowItWorks2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(HowItWorks, _Component);

  function HowItWorks(props) {
    (0, _classCallCheck3.default)(this, HowItWorks);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HowItWorks.__proto__ || (0, _getPrototypeOf2.default)(HowItWorks)).call(this, props));

    _this.renderHowItWorksContent = function () {
      var sriIcon = require('../../../static/images/sri.png');
      var ussifIcon = require('../../../static/images/ussif-logo.png');
      // const cleanChartImg = require( '../../../static/images/clean-chart.png' )
      var dirtyChartImg = require('../../../static/images/dirty-chart.png');
      var categorySwitchesImg = require('../../../static/images/category-switches.png');
      var categoryChartImg = require('../../../static/images/category-chart.png');

      // const iconMmc = require( '../../../static/images/icn-mmc.svg' )
      // const iconCm = require( '../../../static/images/icn-cm.svg' )
      // const iconNw = require( '../../../static/images/icn-nw.svg' )
      // const iconGm = require( '../../../static/images/icn-gm.svg' )
      // const iconGr = require( '../../../static/images/icn-gr.svg' )

      return _react2.default.createElement(
        'div',
        { styleName: 'how-it-works' },
        _react2.default.createElement(
          'div',
          { styleName: 'how-it-works-inner' },
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            'Mutual funds'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-info' },
            _react2.default.createElement(
              'p',
              null,
              'Mutual funds are baskets of stocks bundled together, sometimes hundreds or thousands of companies. They are some of the most popular investment products for retirement plans, because owning so many company stocks at once helps diversify investment risk. But unless you\'re a financial professional, it can be difficult to find out just what companies are inside the funds you\'re invested in. That\'s where we come in. We examine every holding in thousands of funds to determine if there are investments in gun stocks.'
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            'Sustainable investing'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-info' },
            _react2.default.createElement(
              'p',
              null,
              'Some funds actively choose to invest responsibly, by considering environmental or social issues when choosing companies to invest in. If you\'re thinking about weapon free investing, socially responsible funds can be a good place to start, because they often deliberately avoid companies that make civilian firearms. We feature nearly a hundred socially responsible funds in our database.'
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            'Sustainable investing can offer competitive returns'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-info' },
            _react2.default.createElement(
              'p',
              null,
              'While people may become interested in responsible investing because of personal values and goals, that doesn\'t mean they\'re not looking for a competitive financial return on their investments. Fortunately, the evidence is clear: sustainable and responsible investors do not have to pay more to align their investments with their values, or to avoid companies with poor environmental, social or governance practices. ',
              _react2.default.createElement(
                _components.Link,
                { to: _config2.default.links.ussifperf, title: 'Performance and SRI', xstrong: true },
                'The Forum for Sustainable and Responsible Investment'
              ),
              ' has collected the research.'
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            'Finding a fund'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-info' },
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Gun Free Funds'
              ),
              ' sources financial data on equities and mutual funds from Morningstar. Our database contains information on thousands of U.S. open-end and exchange traded mutual funds, some of the most common funds held in 401(k)s, 403(b)s, and other retirement plans.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Search for mutual funds using name, ticker symbol, or asset manager. ',
              _react2.default.createElement(
                _components.Link,
                { to: _config2.default.routes.clean, xstrong: true, title: 'Search funds' },
                'Use the search page'
              ),
              ' to filter funds by investing style, fund family, and more. When you find a fund you\'re looking for, click on it to see the full results.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'We don\'t have everything in our database \u2014 we only screen mutual funds that own direct stock investments, and can only display up to 3,000. Looking for your favorite fund and can\u2019t find it? With more resources, we could include more funds \u2014 ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: _config2.default.links.donate, title: 'Donate to As You Sow' },
                'make a gift today to make a difference.'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            'Screening a fund'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-info' },
            _react2.default.createElement(
              'p',
              null,
              'For each mutual fund in our database, we examine every holding and determine if it is a stock issued by a gun manufacturer or a gun retailer.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'We only look for direct stock holdings in gun companies. That means that holdings that are not stocks, like corporate bonds, are not analyzed. In the fund\'s investment profile, we show a "Percent Rated" metric, equivalent to the percent of the fund that is invested in stocks. The higher a fund\u2019s Percent Rated value, the more holdings we were able to examine. A fund with a lower Percent Rated value may have hidden gun-related investments that our tool cannot account for, in the form of bond holdings or other asset types.'
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'sidebar' },
            _react2.default.createElement(
              'div',
              { styleName: 'sidebar-title' },
              _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-info-circle', nospace: true }),
              '\xA0',
              _react2.default.createElement(
                'em',
                null,
                'Measuring long holdings only'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'sidebar-info' },
              _react2.default.createElement(
                'p',
                null,
                'When calculating a fund\'s exposure to a screen list, we only consider the portfolio\'s long investments, ignoring any shorts or liabilities. The formula for holding weight is ',
                _react2.default.createElement(
                  'em',
                  null,
                  'holding market value divided by the sum of the market value for all long holdings in the portfolio.'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            'If a fund holds stock in a gun company'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-info' },
            _react2.default.createElement(
              'p',
              null,
              'We use two different gun company categories, grouped into two screens.'
            ),
            _react2.default.createElement(_components.ScreenedCompanies, null)
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            'We calculate the fund\'s gun grade'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-info' },
            _react2.default.createElement(
              'p',
              null,
              'Mutual funds can have a varying number of holdings, from less than one hundred to several thousand. We calculate the total number of flagged holdings in the fund, and the total amount and percentage of the fund\u2019s assets that are invested in those companies.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Based on what companies a fund owns, it is assigned one of five civilian firearm grades.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'risk-bullet' },
              _react2.default.createElement(_components.Grade, { grade: 1, large: true }),
              _react2.default.createElement(
                'p',
                { styleName: 'screen-icon-label' },
                'No holdings flagged for our civilian firearm screens. Assigned a grade of A.'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'risk-bullet' },
              _react2.default.createElement(_components.Grade, { grade: 2, large: true }),
              _react2.default.createElement(
                'p',
                { styleName: 'screen-icon-label' },
                'Fund is invested in civilian firearm retailers, but no holdings flagged for our civilian firearm manufacturers screen. Assigned a grade of B.'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'risk-bullet' },
              _react2.default.createElement(_components.Grade, { grade: 3, large: true }),
              _react2.default.createElement(
                'p',
                { styleName: 'screen-icon-label' },
                'Fund is invested in civilian firearm manufacturers, below the threshold of 0.1%. Assigned a grade of C.'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'risk-bullet' },
              _react2.default.createElement(_components.Grade, { grade: 4, large: true }),
              _react2.default.createElement(
                'p',
                { styleName: 'screen-icon-label' },
                'Fund is invested in civilian firearm manufacturers, above the threshold of 0.1% and below 0.4%. Assigned a grade of D.'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'risk-bullet' },
              _react2.default.createElement(_components.Grade, { grade: 5, large: true }),
              _react2.default.createElement(
                'p',
                { styleName: 'screen-icon-label' },
                'Fund is invested in civilian firearm manufacturers, above the threshold of 0.4%. Assigned a grade of F.'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'These thresholds reflect the distribution of results across funds, placing an approximately equal number of funds from the analysis universe in the C, D, and F grade ranges.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'If a fund has direct stock investments in gun manufacturers or major gun retailers, you\'ll see a chart like this, showing the overall exposure.'
            ),
            _react2.default.createElement('img', {
              styleName: 'dirty-chart-img',
              src: dirtyChartImg,
              alt: 'Chart for fund that owns stock in gun companies'
            }),
            _react2.default.createElement(
              'p',
              null,
              'Next to the chart, you\'ll see the exposure breakdown for each of the gun categories.'
            ),
            _react2.default.createElement('img', {
              styleName: 'category-switches-img',
              src: categorySwitchesImg,
              alt: 'Breakdown of gun exposure for each of the gun categories'
            }),
            _react2.default.createElement(
              'p',
              null,
              'If you click a category that a fund has exposure to, you\'ll see the breakdown of the individual companies in that category that the fund owns.'
            ),
            _react2.default.createElement('img', {
              styleName: 'category-chart-img',
              src: categoryChartImg,
              alt: 'Chart for a single gun category'
            })
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            'We track sustainable funds'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-info' },
            _react2.default.createElement(
              'p',
              null,
              'We use Morningstar\'s "sustainability mandate" indicator to determine which funds are displayed as socially responsible. Funds with sustainability mandates often make investment decisions based on issues like environmental responsibility, human rights, or religious views. A socially responsible fund may take a proactive stance by selectively investing in, for example, environmentally-friendly companies, or firms with good employee relations. They may also avoid investing in companies involved in promoting alcohol, tobacco, or firearms, or in the defense industry. Look for this symbol to find funds that are designated socially responsible.'
            ),
            _react2.default.createElement('img', {
              styleName: 'sri',
              src: sriIcon,
              alt: 'Socially responsible fund',
              'data-multiline': true,
              'data-effect': 'solid',
              'data-html': true,
              'data-for': 'sri-icons-tooltip',
              'data-place': 'bottom',
              'data-tip': '<div style=\'max-width:200px;\'>Designated a socially responsible fund by Morningstar. Socially responsible funds consider issues like the environment and human rights.</div>'
            }),
            _react2.default.createElement(
              'p',
              null,
              'The Forum for Sustainable and Responsible Investment is a group advancing sustainable, responsible, and impact investing. Asset managers who are members of US-SIF often have policies to exclude or restrict investments in companies involved in the production, licensing, and/or retailing of civilian firearms. Look for this symbol to find funds that are members of US-SIF.'
            ),
            _react2.default.createElement('img', {
              styleName: 'ussif',
              src: ussifIcon,
              alt: 'Member of US-SIF, the Forum for Sustainable and Responsible Investment',
              'data-multiline': true,
              'data-effect': 'solid',
              'data-html': true,
              'data-for': 'sri-icons-tooltip',
              'data-place': 'bottom',
              'data-tip': '<div style=\'max-width:200px;\'>Member of US-SIF, the Forum for Sustainable and Responsible Investment</div>'
            }),
            _react2.default.createElement(_reactTooltip2.default, { id: 'sri-icons-tooltip' })
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            'Gun free action toolkit'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-info' },
            _react2.default.createElement(
              'p',
              null,
              'When you\'re done looking up funds and finding the data you need, what\'s next? You can learn how to make a change and move your money with our ',
              _react2.default.createElement(
                _components.Link,
                { to: _config2.default.routes.toolkit, xstrong: true, title: 'Gun free action toolkit' },
                'gun free action toolkit'
              ),
              '. Whether you\u2019re an individual investor or if your investments are in your employer-sponsored plan at work, our step-by-step toolkit can help. There\'s an in-depth guide to responsible investing, links to external resources, a sample letter to send to your employer 401(k) manager, and more \u2014 everything you need to make a change and get started investing your money gun free.'
            )
          )
        )
      );
    };

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(HowItWorks, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var title = 'How it works';
      var description = 'Get your money out of guns. Gun Free Funds tracks thousands of mutual funds commonly found in retirement plans.';
      var url = _config2.default.domain + _config2.default.routes.howitworks;

      var bannerImage = 'green';
      var bannerHeadline = 'How it works';
      var bannerSubtitle = 'Getting started with Gun Free Funds';

      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet(title, description, url),
        _react2.default.createElement(
          'div',
          { styleName: 'image-banner' },
          _react2.default.createElement(
            'div',
            { styleName: 'image-banner-container' },
            _react2.default.createElement(
              'div',
              { styleName: 'image-banner-container-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'image-banner-' + bannerImage },
                _react2.default.createElement(
                  'div',
                  { styleName: 'image-banner-headline' },
                  bannerHeadline
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'image-banner-subtitle' },
                  bannerSubtitle
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'page' },
          _react2.default.createElement(
            'div',
            { styleName: 'container' },
            _react2.default.createElement(
              'div',
              { styleName: 'container-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'title' },
                'Methodology and companies we screen for'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'lede' },
                'Gun Free Funds sources financial data from Morningstar, an investment research company. We use Morningstar\u2019s mutual fund and stock data to analyze funds and find civilian firearm investments. Our database covers thousands of the most popular mutual funds, the type of investments most common in retirement plans like employer-offered 401(k)s.'
              ),
              _react2.default.createElement(_components.Changelog, null)
            )
          )
        ),
        _react2.default.createElement(_components.Works, null),
        this.renderHowItWorksContent(),
        _react2.default.createElement(_components.GetStartedInput, null),
        _react2.default.createElement(
          'div',
          { styleName: 'ab-container' },
          _react2.default.createElement(
            'div',
            { styleName: 'ab-container-inner' },
            _react2.default.createElement(_components.AboutBanner, null)
          )
        )
      );
    }
  }]);
  return HowItWorks;
}(_react.Component)) || _class);
exports.default = HowItWorks;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/HowItWorks/HowItWorks.js
// module id = 1292
// module chunks = 0